module.exports = __webpack_public_path__ + "static/media/spinner2.9447da79.gif";